import { Component, Input, OnInit, ViewEncapsulation, inject, signal } from '@angular/core';
import { CoreApiConfiguration } from '@nha/api/core/core-api-configuration.class';
import { appSettings } from '@nha/config';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';

import { NHATestDirective } from '../../directives/test/test.directive';
import { MatBadgeModule } from '@angular/material/badge';

// Some services hand back Guid.Empty for a person they could not resolve; there is no photo
// behind it, so it is treated like no guid at all rather than requested and left broken.
const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

@Component({
	selector: 'nha-avatar',
	templateUrl: './avatar.component.html',
	styleUrls: ['./avatar.component.scss'],
	encapsulation: ViewEncapsulation.None,
	imports: [NHATestDirective, MatIconModule, MatTooltipModule, MatBadgeModule]
})
export class NHAAvatarComponent implements OnInit {
	private coreApiConfig = inject(CoreApiConfiguration);

	private _guid = '';

	public source: string;

	// Set when the photo request fails (404, network); the placeholder icon shows instead of the
	// browser's broken-image glyph. Cleared whenever the guid changes.
	readonly imageFailed = signal(false);

	@Input() type: 'student' | 'staff';
	@Input() size: number = 60;
	@Input() indicator: string;
	@Input() indicatorMessage: string;
	@Input() showSelfPacedBadge: boolean = false;

	@Input()
	set guid(guid: string) {
		this._guid = guid === EMPTY_GUID ? '' : guid;
		this.imageFailed.set(false);

		if (!this.type) {
			throw new Error(`Must specify [type] property to avatar that has the [guid] property specified'.`);
		}

		this.source = this.sourceFor(this._guid);
	}

	get guid(): string {
		return appSettings.featureFlags?.includes('Core|EnableProfilePhotos') ? this._guid : null;
	}

	ngOnInit(): void {
		this.source = this.sourceFor(this.guid);
	}

	onImageError(): void {
		this.imageFailed.set(true);
	}

	private sourceFor(guid: string): string {
		return `${this.coreApiConfig.getBaseUrl()}${this.type}/profile-image/160/${guid}`;
	}
}
